import globalConfig from "@/config/global"
import { makePath } from "@/fns/File"
import { createFetcher, request } from "@101studios/request"
import { RefinementCtx } from "zod"

export const getSessionToken = () =>
  globalConfig.sessionKey ? localStorage.getItem(globalConfig.sessionKey) : null

export const api = createFetcher((url, opts) => {
  return request(makePath(globalConfig.api, url), {
    ...opts,
    throwCanceled: false,
    throwNetwork: false,
    credentials: "include",
    headers: {
      ...opts?.headers,
    },
  })
})

export const apiRefine =
  (endpoint: string, service: any): ((arg: any, ctx: RefinementCtx) => void) =>
  data =>
    console.error({
      endpoint,
      service,
      data,
    })

/**
 * types
 */
export type NoContent = {
  //
}
export type NoError = {
  code: "FETCH_ERROR"
}
export type ErrorCode<T extends string> = {
  code: T
}
export type AuthErrorCode<T extends string = "INVALID_AUTH_SESSION"> = {
  code: T | "INVALID_AUTH_SESSION"
}
export type AdminErrorCode<T extends string = "INVALID_AUTH_SESSION"> = {
  code: T | "RESOURCE_NOT_ALLOWED" | "INVALID_AUTH_SESSION"
}
